import axios from 'lib/axios'

interface Message {
  is_user: boolean
  text: string
}

interface MessagesBody {
  messages: Message[]
}

const connectAgent = async (messages: MessagesBody) => {
  const apiUrl = `/api/ai/skills-agent`

  try {
    const response = await axios.post(apiUrl, messages)
    return response.data
  } catch (error) {
    console.error('error connecting to the AI agent', error)
  }
}

export default connectAgent
